const ReportMaestri = () => {
    return (
        <div>
            <h1>Report Maestri</h1>
        </div>
    )
}

export default ReportMaestri